import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import AttachmentForm, {AttachmentFormProps} from "../../attachment/AttachmentForm";
import {modalClose} from "../genericFunctions";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, AttachmentFormProps {
}

type Props = OwnProps;

// @ts-ignore
const AttachmentModal = NiceModal.create<Props>(({createAttachment, onClose, header, ...rest}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <AttachmentForm createAttachment={createAttachment} {...rest}/>
        </SlideOver>
    )
})

export default AttachmentModal;
